import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import BahrainReqMain from './BahrainReqMain';
const BahrainReq = () => {
  return (
    <div className="uaeReqContainer">
      <BahrainReqMain/>
    </div>
  );
};

export default BahrainReq;
